import { useState } from "react";
import { Form, FormButton, Input } from "semantic-ui-react";
import { Field } from "../ui";
import { useSetupCallRecordingApi } from "../../hooks/useSetupCallRecordingApi";
import { style } from "../../style";

const CallRecordingApiSetupForm = () => {
  const [details, setDetails] = useState({
    api_url: "",
    api_key: "",
    username: "",
    password: "",
  });

  // Full reload so /me picks up the new setup and the calls pages appear
  const { setupCallRecordingApiMutate, isLoading, formErrors } =
    useSetupCallRecordingApi(() => window.location.assign("/calls"));

  const handleSubmit = () => {
    setupCallRecordingApiMutate(details);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field variant="form" label="API URL" error={formErrors?.api_url}>
        <Input
          value={details.api_url}
          disabled={isLoading}
          onChange={(e, { value }) =>
            setDetails({ ...details, api_url: value })
          }
        />
      </Field>
      <Field variant="form" label="API Key" error={formErrors?.api_key}>
        <Input
          type="password"
          value={details.api_key}
          disabled={isLoading}
          onChange={(e, { value }) =>
            setDetails({ ...details, api_key: value })
          }
        />
      </Field>
      <Field variant="form" label="Username" error={formErrors?.username}>
        <Input
          value={details.username}
          disabled={isLoading}
          onChange={(e, { value }) =>
            setDetails({ ...details, username: value })
          }
        />
      </Field>
      <Field variant="form" label="Password" error={formErrors?.password}>
        <Input
          type="password"
          value={details.password}
          disabled={isLoading}
          onChange={(e, { value }) =>
            setDetails({ ...details, password: value })
          }
        />
      </Field>
      <FormButton
        type="submit"
        disabled={isLoading}
        loading={isLoading}
        style={{ ...style.primaryButton, width: "100%" }}
      >
        Save
      </FormButton>
    </Form>
  );
};

export default CallRecordingApiSetupForm;
